module.exports = __webpack_public_path__ + "img/img_2.b31c720a.png";